import React, { useEffect } from 'react'

import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-regular-svg-icons'
import { styled } from '@mui/material'
import { GridColumnGroupHeaderParams } from '@mui/x-data-grid-premium'

import { Icon } from '../../Icon/Icon'
import { IconButton } from '../../IconButton/IconButton'
import { useCollapsibleHeaderContext } from './CollapsibleHeaderContext'

export type CollapsibleHeaderProps = GridColumnGroupHeaderParams & {
  groupFields: string[] // Fields that belong to the group
  numColumnsWhenCollapsed?: number
}

export const CollapsibleHeader: React.FC<CollapsibleHeaderProps> = ({ groupFields, numColumnsWhenCollapsed = 2, ...props }) => {
  const { columnGroupVisibility, updateColumnGroupVisibility } = useCollapsibleHeaderContext()
  const getColumnGroupVisibility = (groupId: string | null) => {
    if (!groupId) return true

    return columnGroupVisibility[groupId]
  }

  // Update columnVisibilityModel on initial load based on columnGroupVisibility
  useEffect(() => {
    if (!columnGroupVisibility || !props.groupId) return

    updateColumnGroupVisibility(props.groupId, groupFields, getColumnGroupVisibility(props.groupId), numColumnsWhenCollapsed)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getCollapseFeatureIcon = (isVisible: boolean) =>
    isVisible ? (
      <StyledCollapseIcon icon={faMinusCircle}/>
    ) : (
      <StyledCollapseIcon icon={faPlusCircle}/>
    )

  const icon = props.groupId ? getCollapseFeatureIcon(
    getColumnGroupVisibility(props.groupId),
  ) : null

  return (
    <HeaderRoot>
      <span>{props.headerName ?? props.groupId}</span>{' '}
      {numColumnsWhenCollapsed < groupFields.length && <StyledIconButton
        round
        aria-label="toggle-collapse"
        onClick={() => {
          if (props.groupId) {
            updateColumnGroupVisibility(props.groupId, groupFields, !getColumnGroupVisibility(props.groupId), numColumnsWhenCollapsed)
          }
        }}
      >
        {icon}
      </StyledIconButton>}
    </HeaderRoot>
  )
}

const HeaderRoot = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  '& span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: theme.spacing(0.5),
  },
}))

const StyledIconButton = styled(IconButton)`
  margin: 0 0 2px -4px;
`

const StyledCollapseIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
`